import { apiFetch } from './client';
import type {
  ConsumerOffer,
  ConsumerSelectRequest,
  ConsumerSelectResponse,
  FeedbackSubmitRequest,
} from '../types/dtos';

export async function getOffer(token: string): Promise<ConsumerOffer> {
  return apiFetch<ConsumerOffer>(`/v1/book/${encodeURIComponent(token)}`);
}

export async function submitSelection(
  token: string,
  body: ConsumerSelectRequest,
): Promise<ConsumerSelectResponse> {
  return apiFetch<ConsumerSelectResponse>(`/v1/book/${encodeURIComponent(token)}/select`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function submitFeedback(
  token: string,
  body: FeedbackSubmitRequest,
): Promise<{ id: string; scope: string }> {
  return apiFetch(`/v1/book/${encodeURIComponent(token)}/feedback`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
